import { keyBy, sortByProp } from '../../../../helpers/common'

export const handleData = (data = [], ids = [], years = []) => {
  if (!data.length) return {}

  const result = {}

  ids.forEach((id) => {
    const item = data.find((item) => item.vsicId === id)
    result[id] = {
      id,
      vsicName: item.vsicName,
    }
  })

  ids.forEach((id) => {
    years.forEach((year) => {
      const dataItem =
        data.find((item) => item.vsicId === id && item.year === year) || {}
      result[id][`${year}-value`] = dataItem.value
      result[id][`${year}-contribution`] = dataItem.contribution
      result[id][`${year}-growthRate`] = dataItem.growthRate
    })
  })

  return result
}

export const handleYearHeader = (years = []) => {
  const initTableHeader = [
    {
      title: 'industryOverview.macroeconomics.Name',
      colId: 'vsicName',
      isI18n: true,
      thStyle: {
        width: 200,
      },
    },
  ]

  years.sort().forEach((year, index) => {
    initTableHeader[index + 1] = {
      title: year,
      colId: `${year}-vsicId`,
      childCol: [
        {
          title: 'industryOverview.macroeconomics.VALUE',
          colId: `${year}-value`,
          isI18n: true,
          thStyle: {
            justifyContent: 'flex-end',
          },
          tdStyle: {
            textAlign: 'right',
          },
        },
        {
          title: 'industryOverview.macroeconomics.CONTRIBUTION_PERCENT',
          colId: `${year}-contribution`,
          isI18n: true,
          thStyle: {
            justifyContent: 'flex-end',
          },
          tdStyle: {
            textAlign: 'right',
          },
        },
        {
          title: 'industryOverview.macroeconomics.GROWTH_RATE_PERCENT',
          colId: `${year}-growthRate`,
          isI18n: true,
          thStyle: {
            justifyContent: 'flex-end',
          },
          tdStyle: {
            textAlign: 'right',
          },
        },
      ],
    }
  })

  return initTableHeader
}

export const handleYearImportExport = (payload = []) => {
  const yearImportExport = {}

  payload.forEach((item) => {
    yearImportExport[`year${item}`] = {
      label: item,
      value: item,
    }
  })

  return yearImportExport
}

export const formatDataForChart = (years = [], data = []) => {
  const result1 = []
  const result2 = []

  const dataLevel0 = keyBy(
    data.filter((item) => item.vsicId === 0),
    'year',
  )
  const dataMain = keyBy(
    data.filter((item) => item.isMain),
    'year',
  )

  years.forEach((year) => {
    result1.push({
      year,
      name: dataLevel0[year]?.vsicName,
      value: dataLevel0[year]?.growthRate,
      realValue: dataLevel0[year]?.value,
    })
    result2.push({
      year,
      name: dataMain[year]?.vsicName,
      value: dataMain[year]?.growthRate,
      realValue: dataMain[year]?.value,
    })
  })

  return [
    sortByProp(result1, 'year', false),
    sortByProp(result2, 'year', false),
  ]
}

export const formatDataChartIndustry = (data, year) => {
  return sortByProp(
    data
      .filter((item) => item.year === year)
      .map((item) => ({
        name: item.vsicName,
        value: item.value,
        isMain: item.isMain,
      })),
    'value',
    true,
  )
}

export const getHeadersFollowColumn = (headers, column) => {
  const result = []

  headers.forEach((item) => {
    if (item?.childCol) {
      result.push({
        ...item,
        childCol: item.childCol.filter(
          (child) =>
            child.title === 'industryOverview.macroeconomics.' + column,
        ),
      })
    } else {
      result.push(item)
    }
  })

  return result
}
